var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-scroll-x-transition',{attrs:{"group":"","hide-on-leave":""}},_vm._l((_vm.activeStreamStore.viewers),function(selection,i){return _c('v-chip',{key:i,staticClass:"ma-1",style:({
      backgroundColor: _vm.backgroundColor,
      color: _vm.contentColor,
    }),attrs:{"close":"","dark":"","small":""},on:{"click:close":function($event){return _vm.removeSelection(selection)}}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-account")]),_vm._v(" "+_vm._s(selection)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }